export class MessageDto {
  constructor(isUser, content) {
    this.isUser = isUser;
    this.content = content;
  }
}
